import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

// Deferred load row for the part message cards, styled like VehiclePagedTable's "Load all stock"
export default function LoadMessagesPrompt({ onLoad }: { onLoad: () => void }) {
  const { t } = useTranslation("common");

  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-sm text-gray-500">{t("Messages not loaded")}</span>
      <button
        type="button"
        onClick={onLoad}
        className="inline-flex shrink-0 items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <ArrowPathIcon className="h-3.5 w-3.5" />
        {t("Load")}
      </button>
    </div>
  );
}
